<template>
  <div class="filters-section">
    <DateDropdown @apply-filters="handleApplyFilters($event, 'date')" />
    <SchoolsDropdown
      :key="`schools-${route.query.secondary_organizations}`"
      @apply-filters="handleApplyFilters($event, 'schools')"
    />
    <TypeDropdown @apply-filters="handleApplyFilters($event, 'type')" />
    <button
      v-if="hasActiveFilters"
      class="clear-all-filters-btn"
      :aria-label="$t('search.clearAllFiltersAriaLabel')"
      @click="handleClearAllFilters"
    >
      {{ $t('search.clearAllFilters') }}
    </button>
  </div>
</template>

<script setup>
import { useSearchFilters } from '~/composables/useSearchFilters';
import DateDropdown from './DateDropdown.vue';
import SchoolsDropdown from './SchoolsDropdown.vue';
import TypeDropdown from './TypeDropdown.vue';

const { hasActiveFilters, clearAllFilters } = useSearchFilters();
const route = useRoute();
const { $t } = useNuxtApp();

const emit = defineEmits(['applyFilters']);

function handleApplyFilters(event, filterType) {
  let payload;

  switch (filterType) {
    case 'date':
      payload = {
        start_date: event?.start_date ?? null,
        end_date: event?.end_date ?? null,
      };
      break;
    case 'type':
      payload = {
        query_indices: event ?? null,
      };
      break;
    case 'schools':
      payload = {
        secondary_organizations: event ?? null,
      };
      break;
    default:
      payload = {};
      break;
  }

  emit('applyFilters', payload);
}

function handleClearAllFilters() {
  clearAllFilters();
  emit('applyFilters', {
    secondary_organizations: null,
    query_indices: null,
    start_date: null,
    end_date: null,
  });
}
</script>

<style lang="scss" scoped>
.filters-section {
  position: sticky;
  top: 0;
  z-index: var(--z-index-search-filters);
  padding: 16px;
  display: flex;
  gap: 12px;
}

.clear-all-filters-btn {
  --space-150: 6px;
  --space-300: 12px;
  border-radius: var(--tertiary-button-border-radius);
  background: transparent;
  border: none;
  padding: var(--space-150) var(--space-300);
  font-size: 12px;
  font-weight: 450;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: var(--tertiary-button-text-contrast);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--tertiary-button-hover);
    outline: var(--tertiary-button-hover-border);
  }

  /* Declared after :hover so an equal-specificity hover outline can't replace the
     focus ring when a filter button is both focused and hovered. SO-3775. */
  &:focus-visible {
    outline: var(--tertiary-button-focus-outline);
  }
}
</style>
